import { Controller } from "@hotwired/stimulus"

const ROW_HEIGHT_PX = 60
const DEFAULT_SCROLL_HOUR = 8
const LABEL_OFFSET_PX = 14
const DEFAULT_SCROLL_TOP = DEFAULT_SCROLL_HOUR * ROW_HEIGHT_PX - LABEL_OFFSET_PX

// The calendar's outer element wraps a Turbo Frame that swaps content on week
// navigation. We want the scroll position to survive those swaps (so a
// practitioner who scrolled to 10am stays at 10am after clicking Next).
// We listen on the target-connected lifecycle (fires on initial mount AND on
// frame-swap re-mount) to restore the saved scrollTop, and track user scrolls
// to update the saved value.
export default class extends Controller {
  static targets = ["scrollContainer"]

  initialize() {
    this.savedScrollTop = DEFAULT_SCROLL_TOP
    this.handleScroll = this.handleScroll.bind(this)
  }

  scrollContainerTargetConnected(element) {
    element.scrollTop = this.savedScrollTop
    element.addEventListener("scroll", this.handleScroll, { passive: true })
  }

  scrollContainerTargetDisconnected(element) {
    element.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll(event) {
    this.savedScrollTop = event.target.scrollTop
  }
}
